import {
    Box,
    FormControl,
    Button,
    Card,
    styled,
    Stack,
    Typography,
    FormLabel,
    TextField,
    FormControlLabel,
    Checkbox,
} from '@mui/material'
import {useForm, SubmitHandler} from 'react-hook-form'
import {LoginRequest} from '../../types/LoginRequest'
import {useAuth} from '../../components/hooks/AuthProvider'
import {useNavigate} from 'react-router-dom'
import {useEffect} from 'react'
import {Route} from '../../router'

const LoginCard = styled(Card)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
        maxWidth: '450px',
    },
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
        boxShadow:
            'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
}))

const SignInContainer = styled(Stack)(({theme}) => ({
    'height': 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
    'minHeight': '100%',
    'padding': theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
    },
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        zIndex: -1,
        inset: 0,
    },
}))

const Login = () => {
    const {
        register,
        handleSubmit,
        formState: {errors},
        setError,
    } = useForm<LoginRequest>()

    const navigate = useNavigate()
    const {token} = useAuth()

    useEffect(() => {
        if (token) {
            navigate(Route.HOME, {replace: true})
        }
    }, [])

    const {loginAction} = useAuth()
    const onSubmit: SubmitHandler<LoginRequest> = async (data) => {
        const succeed = await loginAction(data)
        if (!succeed) {
            setError('name', {
                type: 'manual',
                // message: 'Fehlerhafte Anmeldedaten',
            })
            setError('password', {
                type: 'manual',
                message: 'Fehlerhafte Anmeldedaten',
            })
        } else {
            console.log('Login successful')
        }
    }

    return (
        <SignInContainer direction="column" justifyContent="space-between">
            <LoginCard variant="outlined">
                {/* <SitemarkIcon /> */}
                <Typography
                    component="h1"
                    variant="h4"
                    sx={{
                        width: '100%',
                        fontSize: 'clamp(2rem, 10vw, 2.15rem)',
                    }}
                >
                    Hüsser Torsysteme
                </Typography>
                <Box
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                    noValidate
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        gap: 2,
                    }}
                >
                    <FormControl>
                        <FormLabel htmlFor="name">Name</FormLabel>
                        <TextField
                            {...register('name', {
                                required: true,
                            })}
                            error={!!errors.name}
                            helperText={errors.name?.message}
                            placeholder="Dein Name"
                            type="string"
                            autoComplete="name"
                            autoFocus
                            required
                            fullWidth
                            variant="outlined"
                            color={!!errors.name ? 'error' : 'primary'}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel htmlFor="password">Passwort</FormLabel>
                        <TextField
                            {...register('password', {
                                required: true,
                            })}
                            error={!!errors.password}
                            helperText={errors.password?.message}
                            placeholder="••••••"
                            type="password"
                            autoComplete="current-password"
                            required
                            fullWidth
                            variant="outlined"
                            color={!!errors.password ? 'error' : 'primary'}
                        />
                    </FormControl>
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary" />}
                        label="Eingeloggt bleiben"
                    />
                    {/* <ForgotPassword
                                    open={open}
                                    handleClose={handleClose}
                                /> */}
                    <Button type="submit" fullWidth variant="contained">
                        Anmelden
                    </Button>
                    {/* <Link
                                    component="button"
                                    type="button"
                                    onClick={handleClickOpen}
                                    variant="body2"
                                    sx={{alignSelf: 'center'}}
                                >
                                    Forgot your password?
                                </Link> */}
                </Box>
            </LoginCard>
        </SignInContainer>
    )
}

export default Login
